<button appTooltip="perform a cut-out" [ngClass]="{'esk-tool--active': active() === true}"  (click)="active.set(!active())" class="esk-tool">
  <i class="fa fa-scissors"></i>
</button>
@if(active())
{
<button class="esk-tool" style="color: var(--red-7)" (click)="cancel()"><span class="fa fa-times"></span></button>
<button class="esk-tool"  style="color: var(--green-7)" (click)="finished()"><span class="fa fa-check"></span></button>
}

